document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('customer-login-modal');
  
  if (!modal) return;
  
  const overlay = modal.querySelector('.login-modal-overlay');
  const closeBtn = modal.querySelector('.login-modal-close');
  
  // Open modal function
  function openModal(e) {
    e.preventDefault();
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  // Close modal function
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  
  // Method 1: By href attribute
  const accountLinksByHref = document.querySelectorAll('a[href*="/account"]');
  
  accountLinksByHref.forEach(link => {
    const href = link.getAttribute('href');
    // Only intercept login and account pages, not subpages like /account/orders
    if (href === '/account' || href === '/account/login' || href.endsWith('/account') || href.includes('/account/login')) {
      link.addEventListener('click', openModal);
    }
  });
  
  // Method 2: By link text (catches "My account", "Account", "Login", etc.)
  const allLinks = document.querySelectorAll('a');
  
  allLinks.forEach(link => {
    const linkText = link.textContent.trim().toLowerCase();
    const href = link.getAttribute('href');
    
    // Check if link text contains account/login keywords AND points to account page
    if ((linkText.includes('my account') || 
         linkText.includes('my-account') || 
         linkText.includes('login') || 
         linkText.includes('sign in')) && 
        href && 
        (href.includes('/account/login') || href === '/account' || href.endsWith('/account'))) {
      link.addEventListener('click', openModal);
    }
  });
  
  // Close handlers
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }
  
  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      closeModal();
    }
  });
});
